

































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

import WeixinAccount from './weixin_account.vue';
import BankAccount from './bank_account.vue';
import AlipayAccount from './alipay_account.vue';

@Component({
  components: {
    WeixinAccount,
    BankAccount,
    AlipayAccount,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;
}
